module.exports = __webpack_public_path__ + "455c5af3cd45fa0c02b7aa2d4c5578cf.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/png/circle-44.png
// module id = 127
// module chunks = 0